// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WorkspaceActions_wrapper__iVB9L","wrapperAlternative":"WorkspaceActions_wrapperAlternative__1Y3BS"};